import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.IntegrationModule.moduleNavigation', {
    noNewTenantsError: `
        The selected Xero Organisation is already connected to another ApprovalMax Organisation.
        Please select a different Xero Organisation, or reconnect the existing ApprovalMax Organisation.`,
});
